module.exports = __webpack_public_path__ + "static/img/u2.fceb6a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parents/u2.jpg
// module id = rA6V
// module chunks = 0